import { createSelector } from "reselect"
import * as R from "ramda"

import { brandingSelector, supportEmailSelector, supportPhoneSelector } from "../branding/selectors"
import pureTranslate from "./pureTranslate"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const optionsSelector = (state: any) => state.options

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const translationsSelector = (state: any) => state.translations

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const languageIdSelector = (state: any) => state.options.language

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const brandLanguageSelector = (state: any) => state.staticData.brandLanguage

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const brandingTranslationPlaceholdersSelector: any = createSelector(
  [brandingSelector, supportEmailSelector, supportPhoneSelector, languageIdSelector],
  (branding, supportEmail, supportPhone, languageId) => ({
    brandName: branding.get("name"),
    brandDomain: branding.get("domain"),
    companyName: branding.get("company_name"),
    webLink: branding.get("web_link"),
    legalName: "Kiwi.com",
    legalDomain: "https://www.kiwi.com",
    oldBrand: "Skypicker",
    supportEmail,
    supportPhone,
    languageId,
  }),
)

/**
 * @deprecated - use `formatMessage` function or `FormattedMessage` component from react-intl
 */
const translateSelector = createSelector(
  [translationsSelector, optionsSelector, brandingTranslationPlaceholdersSelector],
  (translations, appOptions, brandingTranslationPlaceholders) => {
    if (appOptions.showTranslationKeys) {
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (id: any) => id
    }

    return function translate(
      key: string,
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      vals?: any | null,
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      originalOptions: any | null = {},
      omittedValues: string[] | null = [],
    ) {
      const options = {
        language: appOptions.get("language"),
        translations,
        ...originalOptions,
      } as const

      // @ts-expect-error: Flow to TS migration.
      let values = { ...brandingTranslationPlaceholders, ...vals }

      // @ts-expect-error: Flow to TS migration.
      values = R.omit(omittedValues, values)

      return pureTranslate(key, values, options)
    }
  },
)

export default translateSelector
